const privileges = {
  admin: "ADMIN",
  packages: "PACKAGES",
  articles: "ARTICLES",
  clients: "CLIENTS",
  users: "USERS",
};

export { privileges };
